/* ============================================================
   RIZE SHOPIFY THEME — theme.js
   Vanilla JS, no build step. Event-delegated on data-rz-* hooks
   so section markup stays declarative. Cart uses Shopify's AJAX
   Cart API (/cart/add.js, /cart/change.js, /cart.js) + the Section
   Rendering API to refresh the drawer markup after every change.
   ============================================================ */
(function () {
  'use strict';

  /* ---------------- Cart drawer ---------------- */
  function openCartDrawer() {
    var root = document.querySelector('[data-rz-cart-drawer]');
    if (!root) return;
    root.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
  }
  
  function closeCartDrawer() {
    var root = document.querySelector('[data-rz-cart-drawer]');
    if (!root) return;
    root.removeAttribute('data-open');
    document.body.style.overflow = '';
  }
  
  function refreshCartDrawer() {
    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-rz-cart-drawer]');
        var current = document.querySelector('[data-rz-cart-drawer]');
        if (fresh && current) {
          var wasOpen = current.hasAttribute('data-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) current.setAttribute('data-open', 'true');
        }
        var freshCount = doc.querySelector('[data-rz-cart-count]');
        var currentCount = document.querySelector('[data-rz-cart-count]');
        if (freshCount && currentCount) currentCount.outerHTML = freshCount.outerHTML;
      })
      .catch(function (e) { console.error('Rize: cart refresh failed', e); });
  }
  
  function addToCart(id, quantity, sellingPlan) {
    var body = { id: id, quantity: quantity || 1 };
    if (sellingPlan) body.selling_plan = sellingPlan;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        refreshCartDrawer();
        
        // FIX 1: Auto-Inject the Toast Notification (Foolproof)
        var toast = document.getElementById('rz-cart-toast');
        if (!toast) {
          toast = document.createElement('div');
          toast.id = 'rz-cart-toast';
          toast.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4ade80" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="margin-right:10px;"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg> Added to cart!';
          toast.style.cssText = 'position: fixed; bottom: -100px; left: 50%; transform: translateX(-50%); background: #111; color: #fff; padding: 14px 28px; border-radius: 40px; font-family: sans-serif; font-size: 14px; font-weight: 600; z-index: 9999999; display: flex; align-items: center; box-shadow: 0 10px 30px rgba(0,0,0,0.25); pointer-events: none;';
          document.body.appendChild(toast);
        }
        
        // Reset and trigger the slide-up animation
        toast.style.transition = 'none';
        toast.style.bottom = '-100px';
        void toast.offsetWidth; // Force browser refresh
        toast.style.transition = 'bottom 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
        toast.style.bottom = '40px'; 
        
        // Hide after 3 seconds
        setTimeout(function() {
          toast.style.bottom = '-100px'; 
        }, 3000);
        
        return data;
      })
      .catch(function (e) { console.error('Rize: add to cart failed', e); });
  }
  
  function changeCartLine(itemKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: itemKey, quantity: quantity }),
    }).then(refreshCartDrawer).catch(function (e) { console.error('Rize: cart change failed', e); });
  }
  
  window.RizeCart = { open: openCartDrawer, close: closeCartDrawer, refresh: refreshCartDrawer, add: addToCart, change: changeCartLine };

  /* ---------------- Hero slideshow ---------------- */
  function initHeroSlideshows() {
    document.querySelectorAll('[data-rz-hero]').forEach(function (hero) {
      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-rz-hero-slide]'));
      var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-rz-hero-dot]'));
      if (!slides.length) return;
      var index = 0;
      var timer = null;
      var interval = parseInt(hero.getAttribute('data-rz-hero-interval'), 10) || 5000;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, si) { s.toggleAttribute('data-rz-active', si === index); });
        dots.forEach(function (d, di) { d.toggleAttribute('data-rz-active', di === index); });
      }
      function play() {
        stop();
        timer = setInterval(function () { show(index + 1); }, interval);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      hero.querySelectorAll('[data-rz-hero-prev]').forEach(function (b) { b.addEventListener('click', function () { show(index - 1); play(); }); });
      hero.querySelectorAll('[data-rz-hero-next]').forEach(function (b) { b.addEventListener('click', function () { show(index + 1); play(); }); });
      dots.forEach(function (d, di) { d.addEventListener('click', function () { show(di); play(); }); });
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', play);

      show(0);
      play();
    });
  }

  /* ---------------- Reel carousel ---------------- */
  function initReelTracks() {
    document.querySelectorAll('[data-rz-reel-track]').forEach(function (track) {
      var section = track.closest('[data-rz-reel-section]') || document;
      section.querySelectorAll('[data-rz-reel-scroll]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-rz-reel-scroll'), 10) || 1;
          track.scrollBy({ left: dir * 232, behavior: 'smooth' });
        });
      });
    });
    document.querySelectorAll('[data-rz-reel-like]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var liked = btn.getAttribute('data-rz-liked') === 'true';
        btn.setAttribute('data-rz-liked', liked ? 'false' : 'true');
      });
    });
  }

  /* ---------------- Mobile nav ---------------- */
  function initMobileNav() {
    document.querySelectorAll('[data-rz-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nav = document.querySelector('[data-rz-mobile-nav]');
        if (!nav) return;
        var open = nav.hasAttribute('data-open');
        nav.toggleAttribute('data-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
      });
    });
    document.querySelectorAll('[data-rz-mobile-nav-backdrop]').forEach(function (el) {
      el.addEventListener('click', function () {
        var nav = document.querySelector('[data-rz-mobile-nav]');
        if (nav) nav.removeAttribute('data-open');
      });
    });
  }

  /* ---------------- Email popup ---------------- */
  function initEmailPopup() {
    var popup = document.querySelector('[data-rz-email-popup]');
    if (!popup) return;
    var STORAGE_KEY = 'rize-email-popup-dismissed';
    var delay = parseInt(popup.getAttribute('data-rz-delay'), 10) || 2500;

    function close() {
      popup.removeAttribute('data-open');
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    }
    popup.querySelectorAll('[data-rz-popup-close]').forEach(function (b) { b.addEventListener('click', close); });
    popup.addEventListener('click', function (e) { if (e.target === popup) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && popup.hasAttribute('data-open')) close(); });

    var form = popup.querySelector('[data-rz-popup-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var success = popup.querySelector('[data-rz-popup-success]');
        form.style.display = 'none';
        if (success) success.style.display = 'block';
        setTimeout(close, 1400);
      });
    }

    try {
      if (!sessionStorage.getItem(STORAGE_KEY)) {
        setTimeout(function () { popup.setAttribute('data-open', 'true'); }, delay);
      }
    } catch (e) {}
  }

  /* ---------------- Product form: qty stepper, pack/subscribe swap ---------------- */
  function initProductForms() {
    document.querySelectorAll('[data-rz-product-form]').forEach(function (form) {
      var qtyInput = form.querySelector('[data-rz-qty-input]');
      var qtyDisplay = form.querySelector('[data-rz-qty-display]');
      form.querySelectorAll('[data-rz-qty-minus]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
          qtyInput.value = v; if (qtyDisplay) qtyDisplay.textContent = v;
          updateTotals(form);
        });
      });
      form.querySelectorAll('[data-rz-qty-plus]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = (parseInt(qtyInput.value, 10) || 1) + 1;
          qtyInput.value = v; if (qtyDisplay) qtyDisplay.textContent = v;
          updateTotals(form);
        });
      });

      form.querySelectorAll('[data-rz-pack-option]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          form.querySelectorAll('[data-rz-pack-option]').forEach(function (o) { o.removeAttribute('data-selected'); });
          opt.setAttribute('data-selected', 'true');
          var variantId = opt.getAttribute('data-rz-variant-id');
          var variantInput = form.querySelector('[data-rz-variant-input]');
          if (variantInput) variantInput.value = variantId;
          var mainImage = form.closest('[data-rz-pdp]');
          var newImg = opt.getAttribute('data-rz-pack-image');
          if (mainImage && newImg) {
            var target = mainImage.querySelector('[data-rz-gallery-main] img');
            if (target) target.src = newImg;
          }
          updateTotals(form);
        });
      });

      form.querySelectorAll('[data-rz-subscribe-option]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          form.querySelectorAll('[data-rz-subscribe-option]').forEach(function (o) { o.removeAttribute('data-selected'); });
          opt.setAttribute('data-selected', 'true');
          var isSub = opt.getAttribute('data-rz-subscribe') === 'true';
          form.setAttribute('data-rz-subscribe-active', isSub ? 'true' : 'false');
          var sellingPlanInput = form.querySelector('[data-rz-selling-plan-input]');
          if (sellingPlanInput) sellingPlanInput.value = isSub ? sellingPlanInput.getAttribute('data-rz-selling-plan-id') || '' : '';
          updateTotals(form);
        });
      });

      function updateTotals(form) {
        var selectedPack = form.querySelector('[data-rz-pack-option][data-selected]');
        var basePrice = selectedPack ? parseFloat(selectedPack.getAttribute('data-rz-price')) : parseFloat(form.getAttribute('data-rz-base-price'));
        var compareAt = selectedPack ? parseFloat(selectedPack.getAttribute('data-rz-compare-price') || '0') : parseFloat(form.getAttribute('data-rz-base-compare') || '0');
        var subscribed = form.getAttribute('data-rz-subscribe-active') === 'true';
        var unit = subscribed ? Math.round(basePrice * 0.85) : basePrice;
        var qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
        var total = unit * qty;
        form.querySelectorAll('[data-rz-total-price]').forEach(function (el) { el.textContent = total; });
        form.querySelectorAll('[data-rz-unit-price]').forEach(function (el) { el.textContent = unit; });
        form.querySelectorAll('[data-rz-compare-total]').forEach(function (el) { el.textContent = compareAt ? (compareAt * qty) : ''; });
        form.querySelectorAll('[data-rz-save-amount]').forEach(function (el) { el.textContent = compareAt ? ((compareAt - unit) * qty) : ''; });
      }

      updateTotals(form);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-rz-cart-toggle]').forEach(function (b) { b.addEventListener('click', openCartDrawer); });
    document.querySelectorAll('[data-rz-cart-close], [data-rz-cart-backdrop]').forEach(function (b) { b.addEventListener('click', closeCartDrawer); });
    
    document.body.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-rz-cart-close], [data-rz-cart-backdrop]');
      if (closeBtn) closeCartDrawer();
      var openBtn = e.target.closest('[data-rz-cart-toggle]');
      if (openBtn) openCartDrawer();
      var removeBtn = e.target.closest('[data-rz-cart-remove]');
      if (removeBtn) { e.preventDefault(); changeCartLine(removeBtn.getAttribute('data-rz-cart-remove'), 0); }
      var quickAdd = e.target.closest('[data-rz-quick-add]');
      if (quickAdd) { e.preventDefault(); addToCart(quickAdd.getAttribute('data-rz-quick-add'), 1); }
    });

    // Handle form submissions
    document.body.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-rz-ajax-cart-form]');
      if (!form) return;
      
      // FIX 2: Check if "Buy Now" or "Checkout" button was clicked
      if (e.submitter && (e.submitter.name === 'checkout' || e.submitter.name === 'return_to' || e.submitter.className.indexOf('shopify-payment-button') !== -1)) {
        return; // Let the browser skip the AJAX and naturally redirect you to Checkout!
      }

      e.preventDefault(); // Only intercept standard "Add to Cart"
      var variantInput = form.querySelector('[data-rz-variant-input]');
      var qtyInput = form.querySelector('[data-rz-qty-input]');
      var sellingPlanInput = form.querySelector('[data-rz-selling-plan-input]');
      addToCart(variantInput ? variantInput.value : form.getAttribute('data-rz-base-variant'), qtyInput ? parseInt(qtyInput.value, 10) : 1, sellingPlanInput ? sellingPlanInput.value : null);
    });

    initHeroSlideshows();
    initReelTracks();
    initMobileNav();
    initEmailPopup();
    initProductForms();
  });
  window.openRIZECart = openCartDrawer;
  window.RizeCart = { open: openCartDrawer, close: closeCartDrawer, refresh: refreshCartDrawer, add: addToCart, change: changeCartLine };
})();